<template lang="">
  <v-card outlined color="transparent">
    <template v-if="groupHeadFee && groupHeadFee.length === 0">
      <hr color="#E0E0E0" />
      <v-col class="my-14 d-flex justify-center text-center text--disabled">
        <div>
          Hiện tại chưa có áp dụng nào trong danh sách. <br />Vui lòng thực hiện thao tác thêm áp dụng ở phía trên.
        </div>
      </v-col>
    </template>
    <div v-for="(item, index) in groupHeadFee" :key="index">
      <v-divider></v-divider>
      <div>
        <div class="d-flex justify-space-between px-6 py-4">
          <h3 :id="'list-item-' + item.id">Áp dụng {{ index + 1 }}</h3>
          <v-menu
            v-if="
              ($auth.policies['delete-group-dedution'] && router === 'priority' && !isSubFee) ||
              (router === 'normal' && $auth.policies['delete-group-head-fee'] && !isSubFee) ||
              ($auth.policies['delete-group-refund-fee'] && router === 'priority' && isSubFee) ||
              (router === 'normal' && $auth.policies['delete-group-arrear-fee'] && isSubFee)
            "
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-if="!isClassSetup(item)" v-bind="attrs" v-on="on" icon>
                <v-icon color="primary">mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item>
                <v-list-item-title
                  class="red--text accent-2"
                  style="cursor: pointer"
                  @click="deleteGroupHeadFeeDialog(item.id)"
                  ><v-icon color="red accent-2">mdi-delete-outline</v-icon> Xóa áp dụng</v-list-item-title
                >
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
        <div class="edit-font mx-12">
          <div class="py-2">
            <v-row>
              <v-col cols="2">
                <span>Biểu phí</span>
              </v-col>
              <v-col cols="10">
                <h4>{{ setScope(item.scope) }}</h4>
              </v-col>
            </v-row>
          </div>
          <div class="py-2" v-if="item.group">
            <v-row>
              <v-col cols="2">
                <span>Nhóm đối tượng</span>
              </v-col>
              <v-col cols="10">
                <router-link :to="'/tuition-fee-group-detail/' + item.group.id" style="text-decoration: none"
                  ><h4 class="primary--text">{{ item.group.title }}</h4>
                </router-link>
              </v-col>
            </v-row>
          </div>
          <div class="py-2">
            <v-row>
              <v-col cols="2">
                <span>Quy định</span>
              </v-col>
              <v-col cols="10">
                <h4>{{ setRegulation(item) }}</h4>
              </v-col>
            </v-row>
          </div>
        </div>
      </div>
      <v-card outlined class="pb-6 ma-6">
        <PaymentPeriodTable :paymentPeriod="paymentPeriod" :groupHeadFee="item" />
      </v-card>
    </div>
  </v-card>
</template>
<script>
import PaymentPeriodTable from './paymentPeriodTable.vue'
import { mapActions, mapState } from 'vuex'

export default {
  components: {
    PaymentPeriodTable,
  },
  props: {
    headFee: Object,
  },
  data() {
    return {
      dialog: false,
      createDialog: false,
      paymentPeriod: [],
    }
  },
  computed: {
    ...mapState('tuitonFeeHeadFee', ['groupHeadFee', 'router', 'isSubFee']),
  },
  methods: {
    ...mapActions('tuitonFeeHeadFee', ['deleteGroupHeadFee']),
    isClassSetup(item) {
      return item.period === 'classSetup'
    },
    setScope(scope) {
      switch (scope) {
        case 'group':
          return 'Chung cho cả nhóm đối tượng'
        case 'select':
          return 'Riêng cho từng đối tượng cụ thể'
        default:
          break
      }
    },
    setRegulation(item) {
      const { period, head_fee } = item
      const { type } = head_fee
      let action
      if (type === 'normal') action = 'Thu'
      else action = 'Giảm'
      switch (period) {
        case 'month':
          return `${action} theo Tháng`
        case 'year':
          return `${action} theo Năm`
        case 'semester':
          return `${action} theo Học kì`
        case 'custom':
          return `${action} theo Đợt`
        case 'session':
          return `${action} theo Số buổi học ${item.metadata.session_type === 'attendance' ? '(có điểm danh)' : ''}`
        default:
          break
      }
    },
    deleteGroupHeadFeeDialog(id) {
      this.$dialog.confirm({
        title: 'Xác nhận xóa áp dụng?',
        text: '<div>Thao tác này sẽ không thể hoàn tác.<br/> Bạn có chắc chắn muốn xoá áp dụng?</div>',
        okText: 'XÓA',
        cancelText: 'HỦY',
        type: 'delete',
        done: async () => {
          this.deleteGroupHeadFee(id)
        },
      })
    },
  },
  async created() {},
}
</script>
<style lang="scss" scoped>
.edit-font h4,
.edit-font span {
  font-size: 16px;
  font-weight: 400;
}
</style>
